/*
// init Isotope
var jQuerygrid = jQuery('.small-services2').isotope({
  itemSelector: '.service',
  layoutMode: 'fitRows',
  filter: '.pro'
});
// change is-checked class on buttons
jQuery('.button-group').each( function( i, buttonGroup ) {
  var jQuerybuttonGroup = jQuery( buttonGroup );
  jQuerybuttonGroup.on( 'click', 'button', function() {
    jQuerybuttonGroup.find('.is-checked').removeClass('is-checked');
    jQuery( this ).addClass('is-checked');
  });
});
jQuery('.button-group').on( 'click', 'button', function() {
  var filterValue = jQuery(this).attr('data-filter');
  jQuerygrid.isotope({ filter: filterValue });
});
*/

var service = jQuery('.service'),
    serviceContainer = jQuery('.small-services'),
    section = jQuery('.small-services-wrapper'),
    containerHeight = jQuery('.adjustable-height'),
    serviceClassFilter,
    showThese;

jQuery(document).ready(function() {
    
	jQuery('.button.active').click();
	
});

jQuery('.option-button.button').on('click', function(){  
    serviceClassFilter = jQuery(this).data('filter');
    showThese = serviceContainer.find('.service' + '.' + serviceClassFilter);
    var sectionHeight = section.height();

    jQuery('.filters-button-group').find('.button.active').removeClass('active');
    jQuery(this).toggleClass('active');
    
    var tl = new TimelineLite()
    .to(service, 0.5, {scale:0, opacity:0, ease: Power3.easeOut})
    .set(service, {display:'none'})
    .set(showThese, {display:'block'})
    .to(showThese, 0.8, {scale:1, opacity:1, ease: Power3.easeOut}, '+=0.1')
    .fromTo(section, 1, {height:'sectionHeight', ease: Power3.easeOut},  {height:'initial', ease: Power3.easeIn}, '-=1');

    if (serviceClassFilter == 'all') {    
        var allTL = new TimelineLite()
            .set(section, {height:sectionHeight})
            .to(service, 0.5, {scale:0, opacity:0, ease: Power3.easeOut})
            .set(service, {display:'none'})
            .set(service, {display:'block'})
            .to(service, 0.8, {scale:1, opacity:1, ease: Power3.easeOut}, '+=0.1')
           .fromTo(section,1 , {height:'sectionHeight', ease: Power3.easeOut},  {height:'initial', ease: Power3.easeIn}, '-=1');
    }
          
});